<!-- 안전리더십 > 메인 -->
<template>
  <Loading v-if="isLoading" />
  <div class="content-wrap sl-page-wrap" :class="slPage">
    <div class="navi-area">
      <div class="m-navi-top">
        <c-btn01 :btnText="t('message.dashboard')" @click="slListOpen"/>
      </div>
      <NaviBox02 @closeMobileMenu="slListOpen"/>
    </div>
    <div class="page1">
      <div class="tit-group02">
        <h2 class="tit">{{t('message.quickKPI')}}</h2>
        <div class="navi-btn">
          <v-btn @click="slListOpen"/>
        </div>
      </div>
      <div class="card-group02">
        <div class="card-col ty02">
          <div class="icon ico8" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{totalScore}}<span>{{t('message.point')}}</span></div>
            <div class="txt2">{{t('message.safetyLeadershipScore')}}</div>
          </div>
        </div>
        <div class="card-col ty04">
          <div class="icon ico9" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="inner">
              <div class="txt1">
                <span>{{t('message.totalCount')}}</span>
                <div>{{totalCnt}}<span>{{t('message.count')}}</span></div>
              </div>
              <div class="inner-line"></div>
              <div class="txt1">
                <span>{{t('message.complete')}}</span>
                <div>{{completeCnt}}<span>{{t('message.count')}}</span></div>
              </div>
              <div class="inner-line"></div>
              <div class="txt1">
                <span>{{t('message.completionRate')}}</span>
                <div>{{completePercent}}<span>%</span></div>
                </div>
            </div>
            <div class="txt2">{{t('message.taskStatus')}}</div>
          </div>
        </div>
      </div>
      <div class="page1-inner1">
        <div class="tit-group02">
          <h2 class="tit">{{t('message.schedule')}}</h2>
        </div>
        <div class="content-box">
          <div class="list-group3 scrollbar">
            <div class="box" v-for="(item, index) in periodList" :key="item.idx" >
              <div class="txt-date">{{ index === 0 ? 'TODO' : index === 1 ? t('message.incomplete') : t('message.complete') }}</div>
              <ul>
                <li v-for="(item2, index2) in item.periodList" :key="item2.idx">
                  <v-btn  @click="onClickContent(item2)">
                    <span class="t1">{{ `${item2.leadershipTitle} - ${item2.contentTitle}` }}</span>
                    <span class="t2">{{ `${item2.periodSeq}${t('message.sessionNumber')} ${dayjs(item2.startDate).format('YYYY.MM.DD')}~${dayjs(item2.endDate).format('YYYY.MM.DD')}` }}</span>
                  </v-btn>
                </li>
                <li v-if="item.periodList?.length == 0">
                  <v-btn  @click="">
                    <span class="t1">
                      {{t('message.noPendingTasks')}}
                    </span>
                  </v-btn>
                </li>

              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import LeadershipService from "@/services/leadership.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import dayjs from "dayjs";
import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const isLoading = ref<boolean>(false)
const snackbar = ref(false)
const snackText = ref('')
const slPage = ref('naviOff') //모니터링 메뉴 열고 닫기
const periodList = ref([])
const totalScore = ref(0)
const totalCnt = ref(0)
const completeCnt = ref(0)
const completePercent = ref(0)
const userInfo:any = ref(JSON.parse(localStorage.getItem('user')))

//hook
onMounted(() => {
  getData()
})

//function
const getData=async()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx:companyIdx,
    memberIdx:userInfo.value.memberIdx,
  }
  try{
    isLoading.value = true
    const response:any = await LeadershipService.getLeadershipSummary(params)
    isLoading.value = false
    totalScore.value = Math.round(response.result.totalScore)
    totalCnt.value = response.result.totalCnt
    completeCnt.value = response.result.completeCnt
    completePercent.value = response.result.totalCnt>0?Math.round((response.result.completeCnt / response.result.totalCnt) * 100):0

    //일정
    periodList.value = []
    const todoList = _.filter(response.result.monitoringPeriodList, (item:any) => {
      const doneCnt = item.freeboardAnswerCnt + item.quizAnswerCnt + item.monitoringAnswerCnt
      const todayStr = new Date().toISOString().slice(0, 10)
      const startDate = item.startDate.slice(0, 10)
      const endDate = item.endDate.slice(0, 10)
      return (item.dateStatus !== 'end' && doneCnt < item.periodCnt && startDate <= todayStr && todayStr <= endDate)
    })
    const endList = _.filter(response.result.monitoringPeriodList, (item:any) => {
      const doneCnt = item.freeboardAnswerCnt + item.quizAnswerCnt + item.monitoringAnswerCnt
      return item.dateStatus === 'end' && item.dateStatus === 'end' && doneCnt < item.periodCnt
    })
    const completeList = _.filter(response.result.monitoringPeriodList, (item:any) => {
      const doneCnt = item.freeboardAnswerCnt + item.quizAnswerCnt + item.monitoringAnswerCnt
      return doneCnt >= item.periodCnt
    })
    periodList.value.push({periodList:todoList})
    periodList.value.push({periodList:endList})
    periodList.value.push({periodList:completeList})
  }
  catch(error){
    isLoading.value = true
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const slListOpen=()=>{
  if(slPage.value == 'naviOff')
    slPage.value = 'naviOn'
  else
    slPage.value = 'naviOff'
}

const onClickContent=(item)=>{
  const isInPeriod = dayjs().isBetween(item.startDate, item.endDate, null, '[]')
  if(isInPeriod)
    utils.movePage('/safetyLeadershipRun/1/'+item.leadershipIdx)
  else {
    snackText.value = t('message.invalidPeriodNotice')
    snackbar.value = true
  }
}
</script>


<style lang="scss">
</style>
